<template>
	<div>
		<div class="home-top">
			<img style="width: 100%; height: 100%;" v-if="bannerList.length > 0" :src="$imgUrl + bannerList[0].listImgPc" alt="" @click="jump(item.outLink)">
			<!-- <Carousel loop class="home-top-carousel" height="auto" v-model="bannerIndex" dots="none" :autoplay="true" :autoplay-speed="10000">
				<CarouselItem v-for="(item, index) in bannerList" :key="index" class="home-top-carousel-item">
					<div class="home-top-carousel-item-view">
						<img :src="$imgUrl + item.listImgPc" alt="" @click="jump(item.outLink)">
					</div>
				</CarouselItem>
			</Carousel> -->
		</div>
		<div v-if="lang === 'zh'">
			<div class="sy-top-2">
				<div class="left">
					<div class="left-left">
						<img :src="topSelect === 0 ? require( '../../../static/home_middel_left.png') : require( '../../../static/home_middel_left_1.png')" alt="">
						<div class="xw-top">
							<div class="xw-top-left" @click="topSelect = 0">
								<div v-if="topSelect === 0" class="select-top">
									<i class="iconfont iconanchor-full"></i>
								</div>
								<div class="xw-top-left-title">
									馆内资讯
								</div>

							</div>
							<div class="xw-top-left-sj">

							</div>
							<div class="xw-top-right" @click="topSelect = 1">
								<div v-if="topSelect === 1" class="select-top">
									<i class="iconfont iconanchor-full"></i>
								</div>
								<div class="xw-top-left-title">
									业界动态
								</div>

							</div>
						</div>
						<div class="xw-list">
							<div class="xw-box" v-for="(item, index) in ssxwList" v-if="topSelect == 0" :key="index" @click="toNewsDetails(item.id)" @mousemove="coverIndex=index" @mouseleave="coverIndex=''">
								<div style="font-size: 8px; margin-right: 5px; width: 20px;">
									<i class="iconfont iconright-s" v-if="coverIndex === index"></i>
								</div>
								<div class="xw-time" :style="{fontWeight: coverIndex === index ? 'bold' : ''}">
									{{$moment(item.releaseTime).format('YYYY[/]MM[/]DD')}}
								</div>
								<div class="xw-title" :style="{fontWeight: coverIndex === index ? 'bold' : ''}">
									【新闻】{{item.title}}
								</div>
							</div>
							<div class="xw-box" v-for="(item, index) in gndtList" v-if="topSelect == 1" :key="index" @click="toNewsDetails(item.id)" @mousemove="coverIndex=index" @mouseleave="coverIndex=''">
								<div style="font-size: 8px; margin-right: 5px; width: 20px;">
									<i class="iconfont iconright-s" v-show="coverIndex === index"></i>
								</div>
								<div class="xw-time" :style="{fontWeight: coverIndex === index ? 'bold' : ''}">
									{{$moment(item.releaseTime).format('YYYY[/]MM[/]DD')}}
								</div>
								<div class="xw-title" :style="{fontWeight: coverIndex === index ? 'bold' : ''}">
									【新闻】{{item.title}}
								</div>
							</div>
						</div>
						<div class="xw-bottom">
							<div class="xw-bottom-left">
								关于中国人民解放军海军博物馆讯息以官方网站、公众号推送讯息为准。
							</div>
							<div class="xw-bottom-right" @click="toNewsMore" v-if="(topSelect == 0 && ssxwList.length >= 5) || (topSelect == 1 && gndtList.length >= 5)">
								查看更多
							</div>
						</div>
					</div>
					<div class="left-middel">
						<img src="../../../static/home_middel_middel.png" alt="">
					</div>
					<div class="left-right">
						<img src="../../../static/home_middel_right.png" alt="">
					</div>
				</div>
				<div class="right">
					<img src="../../../static/home-right-bg.png" alt="" class="bg-img">
					<div class="title">
						<div class="title-left-box">
							<div class="select-top">
								<i class="iconfont iconanchor-full"></i>
							</div>
							在线预约
						</div>
						<div class="title-right-box">
							<div style="font-size: 50px; height: 53px;" class="justify-class">
								{{innerCount}}
							</div>
							<div style="font-size: 14px;" class="justify-class">
								今日到馆人数
							</div>
						</div>
					</div>
					<div class="topbar-list">
						<div class="topbar-box" style="border-bottom: 2px solid #55ccee; font-size: 20px;">
							门票预约
						</div>
						<div class="topbar-box" @click="toHdyy" style="font-size: 20px;">
							活动预约
						</div>
						<!-- <div class="topbar-box" @click="toMyMpyy">
							我的预约
						</div> -->
					</div>
					<div class="calendar">
						<Calendar ref="calendar">

						</Calendar>
					</div>
					<div class="content">
						支持个人、亲子、团队、企事业和学校预约
					</div>
					<div class="yuyue-botton" @click="toMpyy" style="font-size: 20px;">
						立即预约
					</div>
				</div>
			</div>
			<div class="sy-top-3">
				<img src="../../../static/home_top_3.png" alt="">
				<div class="left">
					<div class="sy-top-3-box" @click="leftSelect = 0" :style="{backgroundImage: leftSelect === 0 ? 'url(https://www.hjbwg.com/static/ssxw.png)' : 'url(https://www.hjbwg.com/static/home-left.png)'}">
						<div v-if="leftSelect === 0" class="select-top">
							<i class="iconfont iconanchor-full"></i>
						</div>
						基本陈列
					</div>
					<div class="sy-top-3-box" @click="leftSelect = 1" :style="{backgroundImage: leftSelect === 1 ? 'url(https://www.hjbwg.com/static/ssxw.png)' : 'url(https://www.hjbwg.com/static/home-left.png)'}">
						<div v-if="leftSelect === 1" class="select-top">
							<i class="iconfont iconanchor-full"></i>
						</div>
						陆海域展区
					</div>
					<div class="sy-top-3-box" @click="leftSelect = 2" :style="{backgroundImage: leftSelect === 2 ? 'url(https://www.hjbwg.com/static/ssxw.png)' : 'url(https://www.hjbwg.com/static/home-left.png)'}">
						<div v-if="leftSelect === 2" class="select-top">
							<i class="iconfont iconanchor-full"></i>
						</div>
						展教活动
					</div>
					<div class="sy-top-3-box" @click="leftSelect = 3" :style="{backgroundImage: leftSelect === 3 ? 'url(https://www.hjbwg.com/static/ssxw.png)' : 'url(https://www.hjbwg.com/static/home-left.png)'}">
						<div v-if="leftSelect === 3" class="select-top">
							<i class="iconfont iconanchor-full"></i>
						</div>
						音视频欣赏
					</div>
				</div>
				<div class="right-list">
					<div class="right-box" v-for="(item, index) in leftList[leftSelect]" :key="index" @click="toLeftDetails(leftSelect, item.id)">
						<!-- <div v-if="leftSelect === 3">
							<div class="right-box-image">
								<img :src="$imgUrl + item.listImgPc" alt="">
								<div class="right-box-title">
									{{item.shortTitle}}
								</div>
							</div>
							<div class="right-box-bottom">
								<div class="right-box-bottom-content" style="font-size: 16px;">
									{{item.title}}
								</div>
								<div class="right-box-bottom-button">
									查看详情
								</div>
							</div>
						</div> -->
						<div class="mengban">
							<div class="mengban-box-image">
								<img :src="$imgUrl + item.listImgPc" alt="">
							</div>
							<div class="mengban-box-bottom">
								<div class="mengban-box-bottom-content" style="font-size: 16px;">
									{{item.title}}
								</div>
								<div class="mengban-box-bottom-button">
									查看详情
								</div>
							</div>
							<div class="mengban-box-title">
								{{item.shortTitle}}
							</div>
						</div>
					</div>
				</div>
				<div class="right-button" @click="toMore()" v-if="leftList[leftSelect].length > 0">
					查看更多
				</div>
			</div>
			<div class="sy-top-4" style="cursor: pointer;" @click="openUrl">
				<img src="../../../static/home_4.png" alt="">
			</div>
			<div class="gcjp-block">
				<img src="../../../static/sy-bottom.png" alt="" style="width: 100%; height: 100%;">
				<div class="gcjp-top">
					<div class="gcjp-top-left">
						<div class="select-top">
							<i class="iconfont iconanchor-full"></i>
						</div>
						馆藏文物
					</div>
					<div class="gcjp-top-right" @click="toGc">
						查看更多
					</div>
				</div>
				<div class="gcjp-main">
					<div class="gcjp-box" v-for="(item, index) in gcjpList" :key="index" @click="toLeftDetails(5, item.id)">
						<img :src="$imgUrl + item.listImgPc" alt="">
						<div style="margin-top: 5px; color: #001c54; font-size: 16px; overflow: hidden; text-overflow: ellipsis; white-space: normal; width: 100%; height: 22px; line-height: 22px;">
							<span v-if="item.collectionType" style="margin-right: 10px; background-color: #28499d; padding: 0 2px; color: #FFFFFF;">{{item.collectionTypeName}}</span>{{item.title}}
						</div>
						<div style="margin-top: 5px; color: #666666; font-size: 12px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; height: 22px; line-height: 22px;">
							{{item.shortTitle}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="en-main">
				<div class="en-main-top">
					<div class="en-main-top-title">
						The PLA Naval Museum
					</div>
					<div class="en-main-top-content">
						Located at No.8 Laiyang Road, Shinan District,
						facing toward the trestle bridge on the other bank,
						the PLA Naval Museum is adjacent to Lu Xun Park in the east,
						Small Qingdao Park in the west,
						 the boundless sea in the south and Qingdao Signal Hill Park in the north.
						  It covers an area of 141 Mu on land and 212 mu on sea.
						  Established in November 1988 and officially opened to the public on October 1,
						  1989,It is the only large-scale professional military museum built by the PLA Navy in China.
					</div>
					<div class="en-main-top-right">
						<div class="title">
							<div class="title-left-box">
								<div class="select-top">
									<i class="iconfont iconanchor-full"></i>
								</div>
								Reserve
							</div>
							<div class="title-right-box">
								<div style="font-size: 50px; height: 53px;" class="justify-class">
									{{innerCount}}
								</div>
								<div style="font-size: 14px;" class="justify-class">
									Current visitors
								</div>
							</div>
						</div>
						<div class="topbar-list">
							<div class="topbar-box" style="border-bottom: 2px solid #55ccee; font-size: 20px;">
								Tickets
							</div>
							<div class="topbar-box" @click="toHdyy" style="font-size: 20px;">
								Activities
							</div>
							<!-- <div class="topbar-box" @click="toMyMpyy">
								我的预约
							</div> -->
						</div>
						<div class="calendar">
							<Calendar ref="calendar">

							</Calendar>
						</div>
						<div class="content">
							<!-- 支持个人、亲子、团队、企事业和学校预约 -->
						</div>
						<div class="yuyue-botton" @click="toMpyy" style="font-size: 20px;">
							Reserve a Ticket
						</div>
					</div>
				</div>
				<div class="en-main-banner">
					<img src="../../../static/en-home-middle.png" >
				</div>
				<div class="en-main-choose">
					<div class="en-main-choose-left" :style="{backgroundImage: enSelect === 0 ? 'url(../../../static/en_home_left.png)' : ''}" @click="enSelect=0">
						Main Exhibition Hall
					</div>
					<div class="en-main-choose-right" :style="{backgroundImage: enSelect === 1 ? 'url(../../../static/en_home_right.png)' : ''}" @click="enSelect=1">
						Ships and Marine Equipment Exhibition Area
					</div>
				</div>
				<div class="en-box-main">
					<div class="mengban" v-for="(item, index) in enLeftList[enSelect]" :key="index" @click="toEnDetails(enSelect, item.id)">
						<div class="mengban-box-image">
							<img :src="$imgUrl + item.listImgPc" alt="">
						</div>
						<div class="mengban-box-bottom">
							<div class="mengban-box-bottom-content" style="font-size: 16px;">
								{{item.title}}
							</div>
							<div class="mengban-box-bottom-button">
								Details
							</div>
						</div>
						<div class="mengban-box-title">
							{{item.shortTitle}}
						</div>
					</div>
				</div>
				<!-- <div class="en-more">
					More
				</div> -->

			</div>
		</div>
		<!-- <float-view v-if="showView" :json="json" @closeView="closeView"></float-view> -->
	</div>
</template>

<script>
	import FloatView from '@/components/Float.vue';
	import Calendar from '@/components/Calendar.vue';
	export default {
		name: '',
		components: {
			Calendar,
			FloatView
		},
		data () {
			return {
				topSelect: 0,
				leftSelect: 0,
				bannerIndex: 0,
				bannerList: [],
				ssxwList: [],
				gndtList: [],
				leftList: [
					[]
				],
				gcjpList: [],
				coverIndex: "",
				typeList: [],
				mengbanIndex: null,
				innerCount: 0,
				showView: true,
				json:{
					src: '../../static/notify.jpeg',
					left: 0,
					top: 0,
					directionX: 1,
					directionY: 1,
					distance: 2,
					interval: null,
					target: null,
					zIndex: null,
					width: '100px',
					height: '300px',
					noHoverPause: null, //鼠标经过时不停止，为true时不停止
					cursor: null,
				},
				enLeftList: [
					[]
				],
				enSelect: 0
			}
		},
		computed: {
			lang() {
				return this.$store.state.lang
			}
		},
		mounted() {
			document.body.scrollTop = document.documentElement.scrollTop = 0
			let that = this
			that.$store.state.lang = 'zh'
			that.$store.state.showTopImage = false
			that.$store.state.topImage = ''
			that.$store.state.firstSelect = 0
			that.$store.state.secondSelect = ""
			that.$store.state.secondList = []
			that.getBanner()
			that.getInnerCount()
		},
		methods: {
			closeView(){
				this.showView=false;
			},
			getInnerCount() {
				let that = this
				that.$http.post({
					url: '/api/report/getVisitorsNum'
				}).then(res => {
					if(res.code === "S200") {
						that.innerCount = res.data.visitorsNum
					}
				})
			},
			getBanner() {
				let that = this
				var channelIds = [78, 6, 7, 86, 87, 19, 92, 9, 118, 119]
				that.$http.post({
					url: '/api/channel/findContentListByChannelIds',
					data: {
						channelIds: channelIds,
						releaseTerrace: "releasePc",
						siteId: this.lang === 'zh' ? 1 : 3
					}
				}).then(res => {
					that.leftList = []
					that.enLeftList = []
					if(res.code === "S200") {
						res.data.forEach(item => {
							if(item.channelId == 78) {
								that.bannerList = item.contentList
							}
							if(item.channelId == 6) {
								that.ssxwList = item.contentList.splice(0, 5)
							}
							if(item.channelId == 7) {
								that.gndtList = item.contentList.splice(0, 5)
							}
							if(item.channelId == 86) {
								that.leftList.push(item.contentList.splice(0, 4))
							}
							if(item.channelId == 87) {
								that.leftList.push(item.contentList.splice(0, 4))
							}
							if(item.channelId == 19) {
								that.leftList.push(item.contentList.splice(0, 4))
							}
							if(item.channelId == 92) {
								that.leftList.push(item.contentList.splice(0, 4))
							}
							if(item.channelId == 9) {
								that.gcjpList = item.contentList.splice(0, 8)
							}
						})
						console.log(that.leftList);
					}
				})
			},
			jump(url) {
				var jumpUrl = url
				if(jumpUrl.indexOf('http') < 0) {
					jumpUrl = 'http://' + jumpUrl
				}
				if(url) {
					window.location.href = jumpUrl
				}
			},
			toMpyy() {
				let that = this
				that.$http.post({
					url: '/api/ticket/checkTicketConf',
					data: {
						code: 'TICKETDEADLINE'
					}
				}).then(res => {
					if(res.code === "S200") {
						let nowTime = new Date().getTime()
						let day = that.$moment(new Date()).format('YYYY-MM-DD')
						let time = day + ' ' + res.data[0].vals + ':59'
						let configTime = new Date(time).getTime()
						console.log(time)
						if (nowTime > configTime) {
							that.$Message.error('当前时段不可预约，请在' + res.data[0].vals + '前进行预约')
							return
						} else {
							this.$router.push('mpyy')
						}
					}
				})
			},
			toMyMpyy() {
				this.$router.push('wdmpyy')
			},
			toNewsDetails(id) {
				this.$router.push({
					path: '/gnzx_xqy',
					query: {
						news_id: id
					}
				})
			},
			toNewsMore() {
				let that = this
				if(that.topSelect === 0) {
					that.$store.state.firstSelect = 2
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[2].children
					that.$store.state.channelId = that.$store.state.secondList[0].id
					that.$router.push({
						path: '/gnzx'
					})
				} else {
					that.$store.state.firstSelect = 2
					that.$store.state.secondSelect = 1
					that.$store.state.secondList = that.$store.state.titleList[2].children
					that.$store.state.channelId = that.$store.state.secondList[1].id
					that.$router.push({
						path: '/yjdt'
					})
				}
			},
			toLeftDetails(leftIndex, id) {
				let that = this
				if(leftIndex === 0) {
					that.$store.state.firstSelect = 4
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[4].children
					that.$store.state.channelId = that.$store.state.secondList[0].children[0].id
					that.$store.state.chenLieType = "jbcl"
					this.$router.push({
						path: '/jbzl_details',
						query: {
							zlg_id: id
						}
					})
				} else if (leftIndex === 1) {
					that.$store.state.firstSelect = 4
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[4].children
					that.$store.state.channelId = that.$store.state.secondList[0].children[1].id
					that.$store.state.chenLieType = "lhyzq"
					this.$router.push({
						path: '/jbzl_details',
						query: {
							zlg_id: id
						}
					})
				} else if(leftIndex === 3) {
					that.$store.state.firstSelect = ""
					that.$store.state.secondSelect = ""
					that.$store.state.secondList = []
					that.$store.state.channelId = ""
					this.$router.push({
						path: '/news_video_details',
						query: {
							news_id: id
						}
					})
				} else if(leftIndex === 5) {
					that.$store.state.firstSelect = 3
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[3].children
					this.$router.push({
						path: '/gcjp_xqy',
						query: {
							collection_id: id
						}
					})
				}
			},
			toEnDetails(leftIndex, id) {
				let that = this
				if(leftIndex === 0) {
					that.$store.state.firstSelect = 1
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[1].children
					that.$store.state.channelId = that.$store.state.secondList[0].id
					this.$router.push({
						path: '/basic_display_details',
						query: {
							zlg_id: id
						}
					})
				} else if (leftIndex === 1) {
					that.$store.state.firstSelect = 1
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[1].children
					that.$store.state.channelId = that.$store.state.secondList[0].id
					this.$router.push({
						path: '/basic_display_details',
						query: {
							zlg_id: id
						}
					})
				}

			},
			toGc() {
				let that = this
				that.$store.state.firstSelect = 3
				that.$store.state.secondSelect = 0
				that.$store.state.secondList = that.$store.state.titleList[3].children
				that.$store.state.channelId = that.$store.state.secondList[0].id
				that.$router.push('gcjp')
			},
			toMore() {
				let that = this
				if(that.leftSelect == 0) {
					that.$store.state.firstSelect = 4
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[4].children
					that.$store.state.channelId = that.$store.state.secondList[0].children[0].id
					that.$store.state.chenLieType = "jbcl"
					that.$router.push('clzl')
				} else if(that.leftSelect == 1) {
					that.$store.state.firstSelect = 4
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[4].children
					that.$store.state.channelId = that.$store.state.secondList[0].children[1].id
					that.$store.state.chenLieType = "lhyzq"
					that.$router.push('clzl')
				} else if(that.leftSelect == 2) {
					that.$store.state.firstSelect = 6
					that.$store.state.secondSelect = 0
					that.$store.state.secondList = that.$store.state.titleList[6].children
					that.$store.state.channelId = that.$store.state.secondList[0].id
					that.$router.push('hdyy')
				} else if(that.leftSelect == 3) {
					that.$store.state.firstSelect = ""
					that.$store.state.secondSelect = ""
					that.$store.state.secondList = []
					that.$store.state.channelId = ""
					that.$router.push('news_video')
				}
			},
			toHdyy() {
				let that = this
				that.$store.state.firstSelect = 6
				that.$store.state.secondSelect = 0
				that.$store.state.secondList = that.$store.state.titleList[6].children
				that.$store.state.channelId = that.$store.state.secondList[0].id
				that.$router.push('hdyy')
			},
			openUrl() {
				// window.open("http://pano.yidongbwg.com/55/default.html?startscene=79&startactions=lookat(-97.49,14.29,120,0,0");
				window.open("https://vr.hjbwg.com/project/55/default.html");
			}
		}
	}
</script>
<style>
/* html {
 	filter: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg'><filter id='grayscale'><feColorMatrix type='matrix' values='0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0'/></filter></svg>#grayscale");
    filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=.95 );
} */
</style>
<style lang="less" scoped>
	.home-top {
		width: 100%;
		cursor: pointer;
		.home-top-carousel {
			width: 100%;
			.home-top-carousel-item {
				width: 100%;
				.home-top-carousel-item-view {
					width: 100%;
					img {
						width: 100%;
					}
				}
			}
		}
	}
	.sy-top-2 {
		display: flex;
		width: 100%;
		height: auto;
		.left {
			width: 76.1%;
			position: relative;
			.left-left {
				position: absolute;
				left: 0;
				width: 60.3%;
				z-index: 102;
				img {
					width: 100%;
					height: 100%;
				}
				.xw-top {
					position: absolute;
					top: 0;
					left: 0;
					width: 80%;
					height: 20%;
					display: flex;
					.xw-top-left {
						width: 54%;
						position: absolute;
						top: 0;
						left: 0;
						font-size: 24px;
						color: #FFFFFF;
						line-height: 100%;
						z-index: 100;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items:center;
						height: 100%;
						.select-top {
							width: 30px;
							border-radius: 50%;
							line-height: 30px;
							background-color: #FFFFFF;
							color: rgb(79, 97, 170);
							margin-right: 10px;
							i {
								font-size: 18px;
							}
						}
						.xw-top-left-title {
							display: flex;
							align-items:center;
						}
					}
					.xw-top-right {
						width: 53%;
						position: absolute;
						top: 0;
						left: 50.3%;
						font-size: 24px;
						color: #FFFFFF;
						line-height: 100%;
						z-index: 100;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items:center;
						height: 100%;
						.select-top {
							width: 30px;
							border-radius: 50%;
							line-height: 30px;
							background-color: #FFFFFF;
							color: rgb(79, 97, 170);
							margin-right: 10px;
							i {
								font-size: 18px;
							}
						}
						.xw-top-left-title {
							display: flex;
							align-items:center;
						}
					}

				}
				.xw-list {
					position: absolute;
					top: 25%;
					height: 60%;
					left: 40px;
					width: 60%;
					.xw-box {
						display: flex;
						color: #001c54;
						font-size: 20px;
						height: 30px;
						line-height: 30px;
						width: 100%;
						height: 20%;
						cursor: pointer;
						.xw-time {
							width: 80px;
							text-align: left;
						}
						.xw-title {
							width: 80%;
							margin-left: 20px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
							text-align: left;
						}
					}
				}
				.xw-bottom {
					position: absolute;
					top: 85%;
					height: 10%;
					left: 60px;
					width: 65%;
					display: flex;
					justify-content: space-between;
					.xw-bottom-left {
						width: 70%;
						text-align: left;
						font-size: 16px;
						color: #9a3d5a;
					}
					.xw-bottom-right {
						width: 100px;
						height: 35px;
						line-height: 35px;
						text-align: center;
						background-color: rgb(40, 73, 157);
						color: #FFFFFF;
						cursor: pointer;
					}
				}
			}
			.left-middel {
				position: absolute;
				left: 53%;
				width: 47.51%;
				z-index: 101;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.left-right {
				position: absolute;
				left: 90%;
				width: 10.3%;
				z-index: 102;
				img {
					width: 100%;
					height: 100%;
				}
			}
		}
		.right {
			width: 23.98%;
			position: relative;
			z-index: 103;
			.bg-img {
				width: 100%;
				height: 100%;
			}
			.title {
				position: absolute;
				left: 5%;
				width: 95%;
				font-size: 26px;
				top: 0;
				display: flex;
				// height: 30px;
				// line-height: 30px;
				height: 60px;
				color: #FFFFFF;
				font-weight: bold;
				.title-left-box {
					display: flex;
					width: 40%;
					margin-top: 30px;
					white-space: nowrap;
					.select-top {
						width: 30px;
						height: 30px;
						margin-right: 10px;
						margin-top: 5px;
						border-radius: 50%;
						line-height: 25px;
						background-color: #FFFFFF;
						color: rgb(79, 97, 170);
						i {
							font-size: 18px;
						}
					}
				}
				.title-right-box {
					margin-left: 40px;
					width: 36%;
					color: #55ccee;
					.justify-class {
						width: 100%;
						text-align: justify;
					}
					.justify-class:after {
						display: inline-block;
						width: 100%;
						content: '';
					}
				}
			}
			.topbar-list {
				position: absolute;
				left: 5%;
				width: 95%;
				top: 20%;
				display: flex;
				text-align: left;
				justify-content: center;
				.topbar-box {
					padding: 0 10px;
					color: #FFFFFF;
					font-size: 18px;
					height: 24px;
					line-height: 24px;
					cursor: pointer;
					margin-right: 20px;
				}
			}
			.calendar {
				position: absolute;
				left: 5%;
				width: 90%;
				top: calc(20% + 25px);
				height: 50%;
			}
			.content {
				position: absolute;
				left: 0;
				top: 80%;
				font-size: 18px;
				width: 100%;
				padding: 0 1% 5px;
				text-align: center;
				color: #FFFFFF;
				border-bottom: 3px solid #1E5CAF;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
			.yuyue-botton {
				position: absolute;
				left: calc(50% - 60px);
				top: 90%;
				width: 120px;
				text-align: center;
				height: 30px;
				line-height: 30px;
				background-color: #FFFFFF;
				color: #01009A;
				font-size: 14px;
				cursor: pointer;
				border-radius: 5px;
			}
		}
	}
	.sy-top-3 {
		display: flex;
		position: relative;
		margin-top: 5px;
		height: 100%;
		img {
			height: 100%;
			width: 100%;
		}
		.left {
			position: absolute;
			width: 18%;
			top: 30px;
			left: 0;
			display: flex;
			flex-direction: column;
			height: calc(100% - 40px);
			.sy-top-3-box {
				width: 100%;
				height: 24%;
				background-size: 100% 100%;
				font-size: 24px;
				color: #FFFFFF;
				z-index: 100;
				cursor: pointer;
				display: flex;
				justify-content: center;
				align-items: center;
				.select-top {
					width: 30px;
					height: 30px;
					margin-right: 10px;
					border-radius: 50%;
					line-height: 30px;
					background-color: #FFFFFF;
					color: rgb(79, 97, 170);
					i {
						font-size: 18px;
					}
				}
			}
		}
		.right-list {
			position: absolute;
			top: 30px;
			left: 20%;
			width: 75%;
			display: flex;
			.right-box {
				width: 23%;
				cursor: pointer;
				display: flex;
				flex-direction: column;
				margin: 0 1%;
				.mengban {
					display: flex;
					flex-direction: column;
					position: relative;
					width: 100%;
					.mengban-box-image {
						img {
							width: 100%;
							height: 100%;
						}
					}
					.mengban-box-title {
						display: flex;
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background-color: #000000;
						opacity: 0;
						transition: opacity 0.5s;
						text-align: center;
						align-items: center;
						font-size: 16px;
					}
					.mengban-box-title:hover{
						display: flex;
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background-color: #000000;
						opacity: 0.7;
						transition-duration: 0.5s;
						color: #FFFFFF;
						justify-content: center;
						align-items: center;
						font-size: 16px;
					}
					// .mengban-box-title-yincang {
					// 	position: absolute;
					// 	top: 0;
					// 	left: 0;
					// 	width: 100%;
					// 	height: 100%;
					// 	background-color: #000000;
					// 	opacity: 0;
					// 	transition-duration: 1s;
					// }
					.mengban-box-bottom {
						padding: 5px 10px 10px;
						background-color: rgb(40, 73, 157);
						color: #FFFFFF;
						position: relative;


						.mengban-box-bottom-content {
							text-align: center;
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
							color: #FFFFFF;
						}
						.mengban-box-bottom-button {
							margin: 10px auto 0;
							width: 110px;
							height: 30px;
							line-height: 30px;
							background-color: #55CCEE;
							color: white;
							cursor: pointer;
						}
					}
				}
				.right-box-image {
					position: relative;
					img {
						width: 100%;
						height: 100%;
					}
					.right-box-title {
						position: absolute;
						height: 30px;
						line-height: 30px;
						bottom: 0;
						left: 0;
						width: 100%;
						background-color: rgba(0, 0, 0, 0.4);
						color: #FFFFFF;
						font-size: 16px;
						text-align: left;
						overflow: hidden;
						text-overflow: ellipsis;
						padding: 0 10px;
						white-space: nowrap;
					}
				}

				.right-box-bottom {
					padding: 10px 10px 20px;
					background-color: #1659A7;
					color: #FFFFFF;
					position: relative;
					.right-box-bottom-content {
						text-align: left;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						color: #FFFFFF;
					}
					.right-box-bottom-button {
						margin-top: 10px;
						width: 110px;
						height: 30px;
						line-height: 30px;
						background-color: #55CCEE;
						color: white;
						cursor: pointer;
					}
				}
			}
		}
		.right-button {
			height: 35px;
			line-height: 35px;
			position: absolute;
			bottom: 10px;
			right: 5.7%;
			width: 100px;
			background-color: rgb(40, 73, 157);
			color: #FFFFFF;
			font-size: 12px;
			cursor: pointer;
		}
	}
	.sy-top-4 {
		margin-top: 5px;
		width: 100%;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.sy-top-5 {
		margin-top: 5px;
		width: 100%;
		position: relative;
		img {
			width: 100%;
			height: 100%;
		}
		.top {
			display: flex;
			position: absolute;
			top: 30px;
			width: 90%;
			left: 5%;
		}
	}
	.gcjp-block {
		// margin-top: 5px;
		height: 600px;
		position: relative;
		.gcjp-top {
			position: absolute;
			top: 30px;
			left: 11%;
			width: 78%;
			display: flex;
			height: 40px;
			line-height: 40px;
			justify-content: space-between;
			.gcjp-top-left {
				display: flex;
				line-height: 40px;
				font-size: 24px;
				.select-top {
					width: 30px;
					height: 30px;
					margin-right: 15px;
					margin-top: 5px;
					border-radius: 50%;
					line-height: 30px;
					background-color: rgb(79, 97, 170);
					color: #FFFFFF;
					i {
						font-size: 18px;
					}
				}
			}
			.gcjp-top-right {
				width: 100px;
				background-color: rgb(40, 73, 157);
				color: #FFFFFF;
				font-size: 12px;
				cursor: pointer;
				height: 30px;
				line-height: 30px;
				margin-top: 5px;
				text-align: center;
			}
		}
		.gcjp-main {
			position: absolute;
			width: 80%;
			left: 10%;
			top: 100px;
			height: 430px;
			display: flex;
			flex-wrap: wrap;
			.gcjp-box {
				width: 22%;
				margin: 10px 1.5%;
				padding: 10px 1%;
				height: 220px;
				display: flex;
				flex-direction: column;
				cursor: pointer;
				background-color: #FFFFFF;
				border: 1px solid #d6d6d6;
				img {
					width: 100%;
					height: 150px;
				}
				text-align: center;
			}
		}

	}
	.en-main {
		width: 100%;
		height: 983px;
		background-color: #E0E6F2;
		background-image: url(../../../static/en_main.jpeg);
		background-size: 100% 100%;
		overflow: hidden;
		.en-main-top {
			width: 1300px;
			margin: 14px calc(50% - 650px) 0;
			height: 400px;
			background-image: url(../../../static/en-main-top-bg.png);
			background-size: 100% 100%;
			position: relative;
			.en-main-top-title {
				position: absolute;
				top: 25px;
				left: 38px;
				font-size: 38px;
				color: #FFFFFF;
			}
			.en-main-top-content {
				position: absolute;
				width: 700px;
				text-align: left;
				top: 100px;
				left: 38px;
				font-size: 19px;
				color: #2E449A;
				line-height: 30px;
			}
			.en-main-top-right {
				position: absolute;
				top: 15px;
				right: 20px;
				width: 400px;
				height: 380px;
				.title {
					position: absolute;
					left: 5%;
					width: 95%;
					font-size: 26px;
					top: 0;
					display: flex;
					// height: 30px;
					// line-height: 30px;
					height: 60px;
					color: #FFFFFF;
					font-weight: bold;
					.title-left-box {
						display: flex;
						width: 40%;
						margin-top: 30px;
						white-space: nowrap;
						.select-top {
							width: 30px;
							height: 30px;
							margin-right: 10px;
							margin-top: 5px;
							border-radius: 50%;
							line-height: 25px;
							background-color: #FFFFFF;
							color: rgb(79, 97, 170);
							i {
								font-size: 18px;
							}
						}
					}
					.title-right-box {
						margin-left: 40px;
						width: 36%;
						color: #55ccee;
						.justify-class {
							width: 100%;
							// text-align: justify;
						}
						.justify-class:after {
							display: inline-block;
							width: 100%;
							content: '';
						}
					}
				}
				.topbar-list {
					position: absolute;
					left: 5%;
					width: 95%;
					top: 20%;
					display: flex;
					text-align: left;
					justify-content: center;
					.topbar-box {
						padding: 0 10px;
						color: #FFFFFF;
						font-size: 18px;
						height: 24px;
						line-height: 24px;
						cursor: pointer;
						margin-right: 20px;
					}
				}
				.calendar {
					position: absolute;
					left: 5%;
					width: 90%;
					top: calc(20% + 25px);
					height: 50%;
				}
				.content {
					position: absolute;
					left: 0;
					top: 80%;
					font-size: 18px;
					width: 100%;
					padding: 0 1% 5px;
					text-align: center;
					color: #FFFFFF;
					border-bottom: 3px solid #1E5CAF;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
				}
				.yuyue-botton {
					position: absolute;
					left: calc(50% - 110px);
					top: 90%;
					width: 220px;
					text-align: center;
					height: 30px;
					line-height: 30px;
					background-color: #FFFFFF;
					color: #01009A;
					font-size: 14px;
					cursor: pointer;
					border-radius: 5px;
				}
			}
		}
		.en-main-banner {
			width: 1300px;
			margin: 5px calc(50% - 650px) 0;
			height: 100px;
			img {
				height: 100%;
				width: 100%;
			}
		}
		.en-main-choose {
			width: 1300px;
			margin: 10px calc(50% - 650px) 0;
			height: 60px;
			background-image: url(../../../static/en_home.png);
			background-size: 100% 100%;
			position: relative;
			.en-main-choose-left {
				position: absolute;
				left: 0;
				top: 0;
				width: 50%;
				height: 60px;
				line-height: 60px;
				background-size: 100% 100%;
				font-size: 24px;
				color: #FFFFFF;
				text-align: left;
				padding-left: 20px;
				cursor: pointer;
			}
			.en-main-choose-right {
				position: absolute;
				left: 42%;
				top: 0;
				width: 58%;
				height: 60px;
				line-height: 60px;
				background-size: 100% 100%;
				font-size: 24px;
				color: #FFFFFF;
				text-align: left;
				padding-left: 180px;
				cursor: pointer;
			}
		}
		.en-box-main {
			display: flex;
			width: 1300px;
			margin: 10px calc(50% - 650px) 0;
			.mengban {
				display: flex;
				flex-direction: column;
				width: 23%;
				position: relative;
				flex-direction: column;
				margin: 0 1%;
				cursor: pointer;
				.mengban-box-image {
					img {
						width: 100%;
						height: 100%;
					}
				}
				.mengban-box-title {
					display: flex;
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background-color: #000000;
					opacity: 0;
					transition: opacity 0.5s;
					text-align: center;
					align-items: center;
					font-size: 16px;
				}
				.mengban-box-title:hover{
					display: flex;
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background-color: #000000;
					opacity: 0.7;
					transition-duration: 0.5s;
					color: #FFFFFF;
					justify-content: center;
					align-items: center;
					font-size: 16px;
				}
				.mengban-box-bottom {
					padding: 5px 10px 10px;
					background-color: rgb(40, 73, 157);
					color: #FFFFFF;
					position: relative;
					.mengban-box-bottom-content {
						text-align: center;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						color: #FFFFFF;
					}
					.mengban-box-bottom-button {
						margin: 10px auto 0;
						width: 110px;
						height: 30px;
						line-height: 30px;
						background-color: #55CCEE;
						color: white;
						cursor: pointer;
					}
				}
			}
		}
		.en-more {
			margin-top: 20px;

		}
	}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue